/**
 * Empty polyfill stub – modern browsers support Array.at, flat, flatMap,
 * Object.fromEntries, Object.hasOwn, String.trimStart, String.trimEnd natively.
 * Replacing next/dist/build/polyfills/polyfill-module saves ~12 KiB.
 */
export {};
